<template lang="pug">

  .register-component
    form(@submit.prevent='register', @keydown='form.onKeydown($event)', :class="{ 'has-errors': form.errors.any() }")
      slot

    form-success-modal(:form="form")
      template(slot="title") An email has been sent to<br/>{{ resendForm.email }}
      template(slot="message") To complete your account registration, please click on the verification link sent to your email address. If you have not received an email, click the resend button below.
      template(slot="buttons")
        v-button.btn-primary(:loading="resendForm.busy", nativeType="button", @click="resendEmail()") Resend email »

    form-success-modal(:form="resendForm")
      template(slot="title") Success!
      template(slot="message") We have emailed verification link!
      template(slot="buttons")
        router-link.btn.btn-primary(:to="{ name: 'sign-in' }") Sign in

</template>

<script>
import Form from 'vform'
import Cookie from 'js-cookie';

export default {
  name: 'register',

  data: () => ({
    form: new Form(),
    resendForm: new Form()
  }),

  created() {
    if ('extra_cookie' in this.$route.query) {
      const cookie = Cookie.getJSON(this.$route.query.extra_cookie);
      if (cookie) {
        this.form[this.$route.query.extra_cookie] = cookie;
      }
    }
  },

  methods: {
    async register () {
      this.resendForm.email = this.form.email;
      const { data } = await this.form.post(`${window.addiesaas.url}/api/user/register`);
      this.form.reset();

      if ('extra_cookie' in this.$route.query) {
        Cookie.remove(this.$route.query.extra_cookie);
      }
    },

    async resendEmail () {
      await this.resendForm.post(`${window.addiesaas.url}/api/user/register/resend`);
    }
  }
}
</script>
